// import { useMutation } from "react-query";
// import { request } from "../../../config/helpers/axios-instance";
// import { toast } from "react-toastify";

// export const CreateIndentTransfer = () => {
//     const USE_MOCK_DATA = true; // Set to false to use real API

//     return useMutation(
//         ['create-indent-transfer'],
//         async (payload) => {
//             if (USE_MOCK_DATA) {
//                 // Mock API response - simulate network delay
//                 return new Promise((resolve) => {
//                     setTimeout(() => {
//                         resolve({
//                             data: {
//                                 success: true,
//                                 data: {
//                                     indentNo: "ISRQ-100026000007"
//                                 },
//                                 error: ""
//                             }
//                         }      
//                         );
//                     }, 1000); // Simulate 1 second API delay
//                 });
//             } else {
//                 // Real API call
//                 const response = await request({
//                     method: "POST",
//                     url: `/hinai/userorder/indentTransfer`,
//                     data: payload
//                 });
//                 return response;
//             }
//         },
//         {
//             onSuccess: (response) => {
//                 if (response?.data?.success) {
//                     toast.success(response?.data?.data?.message || "Indent transfer request created successfully");
//                 } else {
//                     toast.error(response?.data?.error || "Failed to create indent transfer");
//                 }
//             },
//             onError: (error) => {
//                 toast.error("Failed to create indent transfer request", error);
//             }
//         }
//     );
// };

// make it real api call
import { useMutation } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { toast } from "react-toastify";
import { TENANT_COMPANY_MAP } from "../../../utils/constants";
import { getTenantId } from "../../../utils/helpers";

const CreateIndentTransfer = (quotationId) => {
    const tenantId = getTenantId();
    const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;

    if (!isEasydose) {
        return useMutation(() => Promise.resolve(null));
    }
    return useMutation(
        ["create-indent-transfer", quotationId],
        (payload) =>
            request({
                url: `/hinai/userorder/createIndentRequest/${quotationId}`,
                method: "POST",
                data: payload,
            }),
        {
            onSuccess: (response) => {
                if (response?.data?.success) {
                    toast.success(
                        response?.data?.data?.message ||
                            "Indent transfer request created successfully"
                    );
                } else {
                    toast.error(
                        response?.data?.error ||
                            "Failed to create indent transfer"
                    );
                }
            },
            onError: (error) => {
                const errorMessage = error?.response?.data?.error || 
                                    error?.message || 
                                    "Failed to create indent transfer request";
                toast.error(errorMessage);
            }
        }
    );
};

export { CreateIndentTransfer };